import React from "react";

interface Props {
    height?: `${number}rem`;
    width?: `${number}rem`;
    className?: string;
}

const SkeletonCircle = ({ height = "1rem", width = "20rem", className }: Props) => (
    <span className={`animate-pulse block border-8 border-pine-700 rounded-full ${className}`} style={{ width, height }} />
);

export default SkeletonCircle;
